import { utilities, formUtils } from '@/scripts/common/utilities'
import {
    DATE_TIME_LOCAL,
    MONTH_NAMES,
    DAYS_SHORT
} from '@/scripts/config/locale.config'



export class Datepicker {
    constructor(container, options) {
        if(typeof $ === 'undefined' || typeof  jQuery === 'undefined') {
            console.log('Please Add jQuery for daterange picker')
            return
        }
        this.container = container
        this.input = container.querySelector('[data-picker-input]') || null
        this.labelLinkInput = document.querySelector(`${this.input.dataset.labelLink}`) || null
        this.singleDatepicker = this.input.dataset.dateSingle || false
        this.totalSpan = this.input.dataset.maxSpan || 120;

        this.today = new Date()
        this.tomorrow = new Date(new Date().setDate(new Date().getDate() + 1))
        this.minEndDate = new Date(new Date().setDate(new Date().getDate() + 4))

        this.startDate = this.input.dataset.startDate || this.input.value || this.tomorrow
        this.endDate = this.input.dataset.endDate || this.minEndDate
        this.minDate = this.input.dataset.minDate || false

        this.options = Object.assign({
            pickerOptions: {
                "autoApply": true,
                "locale": {
                    ...DATE_TIME_LOCAL,
                    "monthNames": MONTH_NAMES,
                    "daysOfWeek": DAYS_SHORT
                },
                "maxSpan": false,
                "linkedCalendars": false,
                "parentEl": this.container,
                "startDate": this.startDate,
                "endDate": this.endDate,
                "minDate": this.minDate,
                "singleDatePicker": !!this.singleDatepicker
            }
        }, {
            ...options
        })


        this.init()
    }

    async init() {
        await import(/* webpackChunkName: "daterangepicker" */'@/scss/vendors/_daterange.scss')
        await utilities.loadScript(`https://cdn.jsdelivr.net/momentjs/latest/moment.min.js`, 'momentJs')
        await utilities.loadScript(`/js/daterangepicker.js`, 'daterangeJs')
        
        this.container && this.buildPicker()
    }
    
    buildPicker() {
        $(this.input).daterangepicker(this.options.pickerOptions)
        this.syncVal()
        this._addingEventListeners()
        this.pickerShow()
    }

    syncVal() {
        const labelLinkInput = this.labelLinkInput
        let dates = this.input.value.split(' - ')
        const selectedStartDate = dates[0] ? moment(new Date(dates[0])).format(site.settings.dateDisplayFormat) : null
        const selectedEndDate = dates[1] ? moment(new Date(dates[1])).format(site.settings.dateDisplayFormat) : null

        if(labelLinkInput && this.labelLinkInput.nodeName === 'INPUT') {
            labelLinkInput.value = !selectedEndDate ? `${selectedStartDate}` : `${selectedStartDate} - ${selectedEndDate}`
            return
        }

        labelLinkInput.innerHTML = !selectedEndDate ? `${selectedStartDate}` : `${selectedStartDate} - ${selectedEndDate}`
    }

    // Utility functions
    pickerShow() {
        $(this.input).data('daterangepicker').show()
    }
    
    _setStartDate (startDate) {
        const pickerInput = this.input
        $(pickerInput).data('daterangepicker').setStartDate(startDate)
        $(pickerInput).data('daterangepicker').updateView()
        return this
    }

    _setEndDate (endDate) {
        const pickerInput = this.input
        $(pickerInput).data('daterangepicker').setEndDate(endDate)
        $(pickerInput).data('daterangepicker').updateView()
        return this
    }

    _setMinDate(minDate) {
        const pickerInput = this.input
        $(pickerInput).data('daterangepicker').setMinDate(minDate)
        $(pickerInput).data('daterangepicker').updateView()
        return this
    }

    // Callbacks
    onInputChange(e) {
        this.syncVal()
    }

    // Listeners
    _addingEventListeners() {
        $(this.input).on('change', (e) => this.onInputChange(e))
    }
}